// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ed1d2ff9","732":"11c698d9","977":"e9a867d3"}[chunkId] + ".chunk.js";
};